import Component from '../core/Component'

export default class Antispam extends Component {
    prepare() {
        const fakeDom = document.createElement('div')
        fakeDom.innerHTML = this.element.innerHTML.trim().replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>')

        // get attributes
        const origInput = fakeDom.querySelector('.anti-fill')
        const id = origInput.getAttribute('id')
        const name = origInput.getAttribute('name')
        const key = fakeDom.querySelector(`label[for="${id}"] strong`).textContent

        // append
        const input = document.createElement('input')
        input.type = 'hidden'
        input.name = name
        input.value = key
        this.element.parentNode.appendChild(input)
		
		this.element.parentNode.removeChild(this.element)
    }
}